import { RightArrow } from '@components/svgs';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Biotif from '@styles/Font';
import React, { memo, ReactNode, useEffect, useRef, useState } from 'react';
import { IListMenuProps } from './ListMenu.types';
import styles from './styles.module.scss';

const ListMenu = memo<IListMenuProps>(({ listItems, currentFeatureIndex, onPress }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [currentTab, setCurrentTab] = useState<ReactNode>('-');
  const listRef = useRef<HTMLDivElement>(null);

  const open = Boolean(anchorEl);

  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (_: React.MouseEvent<HTMLElement>, index: number) => {
    onPress(index);
    setAnchorEl(null);
  };

  useEffect(() => {
    const cur = listItems[currentFeatureIndex];
    setCurrentTab(
      cur ? (
        <div>
          <span className={styles.emoji}>{cur.emoji}</span>
          <span>{cur.title}</span>
        </div>
      ) : (
        '-'
      ),
    );
  }, [listItems]);

  return (
    <div className={styles.listMenu} ref={listRef}>
      <List component="nav" aria-label="Device settings" sx={{ bgcolor: 'background.paper' }}>
        <ListItem
          id="button"
          aria-haspopup="listbox"
          aria-controls={styles.menu}
          aria-label="when device is locked"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClickListItem}
        >
          <div className={styles.selected}>{currentTab}</div>
          <RightArrow />
        </ListItem>
      </List>
      <Menu
        id={styles.menu}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'button',
          role: 'listbox',
        }}
        PaperProps={{ style: { width: listRef.current?.clientWidth } }}
      >
        {listItems.map((item, index) => (
          <MenuItem
            key={item.title}
            selected={index === currentFeatureIndex}
            onClick={(event) => handleMenuItemClick(event, index)}
            style={Biotif.style}
          >
            <span className={styles.emoji}>{item.emoji}</span>
            {item.title}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
});

ListMenu.displayName = 'ListMenu';
export default ListMenu;
